import { useState } from "react";
import { FormLabel } from "react-bootstrap";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { SimpleModal } from "src/app/components";
import { SiteTransport } from "src/app/transports/site";

export interface IRemoveProjectManagerContainer {
    selectedRows: any[];
    handlerValueToUpdateGrid(update: boolean): void;
    handleClose(): void;
    showModal: boolean;
}
const RemoveProjectManagerContainer = (props: IRemoveProjectManagerContainer) => {
    const { selectedRows, handlerValueToUpdateGrid, handleClose, showModal } = props;
    const { formatMessage } = useIntl();
    const [loading, setLoading] = useState(false);

    const onSubmit = async () => {
        setLoading(true);
        try {
            await SiteTransport.removeProjectManagers(selectedRows.map((el) => el.id));
            toast.success(formatMessage({ id: "common.notification.success" }));
            handlerValueToUpdateGrid(true);
            handleClose();
        } catch (error: any) {
            toast.error(
                error?.response?.data?.errors[0]?.message ||
                    formatMessage({ id: "common.notification.error" })
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <SimpleModal
            entityName={formatMessage({ id: "common.action.removeProjectManagers" })}
            showModal={showModal}
            handleClose={handleClose}
            formId=""
            loading={loading}
            modalProps={{ size: "sm" }}
            buttonConfirmationAction={onSubmit}
            buttonConfirmationLabel={formatMessage({ id: "common.action.remove" })}
        >
            <FormLabel>
                {formatMessage({ id: "common.action.removeProjectManagers.question" })}
            </FormLabel>
        </SimpleModal>
    );
};

export default RemoveProjectManagerContainer;
